// 公共api
import request from "@/utils/request";

export const url = {
  selectData: "/api/Common/GetSelectItems",
  g_selectData: "/api/GroupCommon/GetSelectItems",
  incomeData: "/api/CompanyHomePage/GetHomeDataForApp", //获取今日营业收入数据
  todayData: "/api/CompanyHomePage/GetCompanyStatisticsInfo", // 获取分店当天和历史数据统计
  changeToken: "/api/Auth/ChangeToken", //切换门店获取新的token Id为目标门店Id
  GetHomeDataForApp: "/api/CompanyHomePage/GetHomeDataForApp", //获取首页数据(移动端)
  GetAccountList: "api/AccountMaintenance/GetAccountList", //消费项目
  User_GetCompany: "/api/User/GetCompanys", //查询用户可切换的门店
  GroupUser_GetCompanys: "/api/GroupUser/GetCompanys", //查询集团可切换的门店
  GroupHomePage_Info: "/api/GroupHomePage/GetGroupInfo", //集团总览数据统计
  GroupHomePage_ChartDataInfo: "/api/GroupHomePage/GetGroupChartDataInfo", //营业额、订单数、出租率、月营业额、门店营业额排名
  GroupHomePage_PieChartDataInfo: "/api/GroupHomePage/GetGroupPieChartDataInfo", //客源统计、付款类型统计、消费类型统计(饼状图)
  GetDefaultItem: "/api/RoomNo/GetDefaultItem", //获取默认预抵，预离时间，默认价类 前端无需传任何数据，此Id为预留的价类Id
  Get_RoomListAsync: "/api/CompanyHomePage/GetHomePageRoomListAsync", //获取今天预入，预离，在住的房号列表
  Get_ChartDataSource: "/api/CompanyHomePage/GetChartDataSource", //获取图表数据源
  Get_TypeStatistics: "/api/CompanyHomePage/GetTypeStatistics",
};

export function getTypeStatistics(data) {
  return request({
    url: url.Get_TypeStatistics,
    method: "post",
    data: data,
  });
}
export function getChartDataSource(data) {
  return request({
    url: url.Get_ChartDataSource,
    method: "post",
    data: data,
  });
}

export function getRoomListAsync(data) {
  return request({
    url: url.Get_RoomListAsync,
    method: "post",
    data: data,
  });
}
export function getSelectData(data) {
  return request({
    url: url.selectData,
    method: "post",
    data: data,
  });
}
export function getGSelectData(data) {
  return request({
    url: url.g_selectData,
    method: "post",
    data: data,
  });
}
export function getCompanys(data) {
  return request({
    url: url.User_GetCompany,
    method: "post",
    data: data,
  });
}
export function getGroupCompanys(data) {
  return request({
    url: url.GroupUser_GetCompanys,
    method: "post",
    data: data,
  });
}
export function getIncomeData(data) {
  return request({
    url: url.incomeData,
    method: "post",
    data: data,
  });
}
export function getTodayData(data) {
  return request({
    url: url.todayData,
    method: "post",
    data: data,
  });
}
export function getChangeToken(data) {
  return request({
    url: url.changeToken,
    method: "post",
    data: data,
  });
}
export function GetHomeDataForApp(data) {
  return request({
    url: url.GetHomeDataForApp,
    method: "post",
    data: data,
  });
}
/**
 *消费项目项
 */
export function GetAccountList(data) {
  return request({
    url: url.GetAccountList,
    method: "post",
    data: data,
  });
}
/**
 *集团总览数据统计
 */
export function GetGroupHomeInfo(data) {
  return request({
    url: url.GroupHomePage_Info,
    method: "post",
    data: data,
  });
}

/**
 *移动端财知收入统计
 */
export function GroupHomePage_ChartDataInfo(data) {
  return request({
    url: url.GroupHomePage_ChartDataInfo,
    method: "post",
    data: data,
  });
}

/**
 *移动端饼图统计(客源统计、付款类型统计、消费类型统计)
 */
export function GroupHomePage_PieChartDataInfo(data) {
  return request({
    url: url.GroupHomePage_PieChartDataInfo,
    method: "post",
    data: data,
  });
}
export function GetDefaultItem(data) {
  return request({
    url: url.GetDefaultItem,
    method: "post",
    data: data,
  });
}
